import { useRouter, useSearchParams } from 'next/navigation';
import { NavigationCarousel } from '@/features/carousel';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { EasyAccess } from '@/features/tag';
import { FAQ_DATA } from '../constants';
interface Props {
  pageUrl: string;
}
const FAQCategories = ({
  pageUrl
}: Props) => {
  const {
    isMobile
  } = useMobileDetect();
  const searchParams = useSearchParams();
  const selectedCategory = searchParams.get('category');
  const router = useRouter();
  const clickCategoryHandler = (id?: string) => {
    const searchParams = new URLSearchParams();
    if (id) {
      searchParams.set('category', id);
      router.push(`${pageUrl}${searchParams.toString() ? '?' + searchParams.toString() : ''}`);
      return;
    } else {
      router.push(pageUrl);
    }
  };
  return <NavigationCarousel className='mb-4 lg:mb-8' options={{
    perView: 2.7,
    spacing: 8,
    mode: 'free',
    breakPoints: {
      mobile: {
        perView: 'auto',
        spacing: 8
      },
      desktop: {
        perView: 'auto',
        spacing: 8
      }
    }
  }} data-sentry-element="NavigationCarousel" data-sentry-component="FAQCategories" data-sentry-source-file="faq-categories.tsx">
            {[{
      category: 'همه سوالات',
      id: undefined
    }, ...FAQ_DATA].map(({
      category,
      id
    }, index) => <EasyAccess key={index} size={isMobile ? 'medium' : 'large'} className='keen-slider__slide !w-fit min-w-fit justify-center' onClick={() => clickCategoryHandler(id)} iconCloseClassName='hidden' isActive={id === selectedCategory || !selectedCategory && index === 0}>
                    {category}
                </EasyAccess>)}
        </NavigationCarousel>;
};
export default FAQCategories;